<mat-card>
  <mat-card-content fxLayout="column">
    <span>{{formattedDate}}</span>
    <span>{{name}}</span>
    <span>{{location}}</span>
  </mat-card-content>
</mat-card>